import BasicTooltip from "../tooltips/BasicTooltip";
import { numberToStringFormat } from "./ControlUtils";
import { useMediaQuery } from "@mui/material";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { utils } from '../../utils';
/*
게시글 정보
BoardId, BoardTitle, BoardType, Content, ReplyBody, BoardHit, ManageId, BoardOrd, CreatedDate, CreateByName, CreatedBy

*/

export default function Columns4Board (t)
{
    const matches = useMediaQuery('(max-width:800px)');
    const columns = [
        {
            field: "RowNum",
            headerName: 'No.',
            flex: 0.5,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "ManageId",
            headerName: t('field.manageid'),
            flex: 0.0,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "BoardId",
            headerName: t('field.boardid'),
            flex: 0.0,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "BoardType",
            headerName: t('field.boardtype'),
            flex: 0.0,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
            
        },
        {
            field: "BoardTitle",
            headerName: t('field.boardtitle'),
            flex: 6.0,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'left',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => (
                <BasicTooltip title={params.row.HasNew === 'Y' ? 
                    (<><NewReleasesIcon fontSize="small" sx={{ verticalAlign: 'middle', color: 'blue'}} /> {`${params.row.BoardTitle} (New)`}</>) : 
                    params.row.BoardTitle} placement="right-end" />
            ),
            valueGetter: ({ value }) => value || "-",
        },
        {
            field: "HasReply",
            headerName: t('field.hasreply'),
            flex: 0.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
        },
        {
            field: "CreatedByName",
            headerName: t('field.createdbyname'),
            flex: 1,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "BoardHit",
            headerName: t('field.boardhit'),
            flex: 1,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            valueFormatter: value => numberToStringFormat(value),
        },
        {
            field: "CreatedDate",
            headerName: t('field.createddate'),
            flex: 1.5,
            type: 'date',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            valueFormatter: (value) => matches ? utils.date.dateToString(value, "YY.MM.DD") : utils.date.dateToString(value, "YYYY-MM-DD"),
        },
        {
            field: "BoardOrd",
            headerName: t('field.boardord'),
            flex: 0.0,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
            valueFormatter: value => numberToStringFormat(value),
        },
        {
            field: "CreatedBy",
            headerName: t('field.createdby'),
            flex: 0.0,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
        },
    ];

    return columns;
};